import { isNetworkError } from "./isNetworkError";

export const parseErrorMessage = (error: string) =>
  isNetworkError(error) ? "Internet Connection Failed" : error;
